module.exports = __webpack_public_path__ + "img/arm-left-front.b871262c.png";